import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['Ore perse a pianificare ogni sera', 'Sessioni del giorno pronte in 30 secondi'], ['Esercizi ripetitivi e noiosi', '120+ varianti per ogni fascia d’età'], ['Allievi che abbandonano', 'Progressione chiara e fidelizzazione alta'], ['Caos nei pagamenti', 'Excel professionale dedicato'], ['Club senza una direzione', '6 volumi per insegnare con metodo']];
export function FinalCTA() {
  return <section className="border-y-4 border-emerald-400 bg-[#101a12] px-5 py-20" data-id="element-38" data-mp="vui4l28fb4bi">
      <div className="mx-auto max-w-3xl text-center" data-id="element-39" data-mp="vwkw5qp855ic">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-40" data-mp="qwzs51v766yr">
          Smetti di improvvisare.{' '}
          <span className="text-emerald-300" data-id="element-41" data-mp="14t3n4xdwajca">
            Inizia a insegnare con un sistema.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-slate-300" data-id="element-42" data-mp="2c56ewecbmno5">
          Unisciti a oltre 2500 Maestri di Tennis che pianificano l’intero anno
          della loro scuola in meno di 5 minuti.
        </p>
        <p className="mt-5 text-xs font-bold uppercase tracking-[.18em] text-emerald-200" data-id="element-43" data-mp="2m21cmv0rsk1d">
          Sessioni · Drills · Progressioni · Agonismo · Business · Tutto
          organizzato
        </p>
        <div className="mt-10 overflow-hidden border border-emerald-300/30 text-left" data-id="element-44" data-mp="2v2r45mizzo9a">
          <div className="grid grid-cols-2 bg-[#1b2b1e] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-45" data-mp="301k74l0nrwv7">
            <p className="p-4 text-slate-300" data-id="element-46" data-mp="34tu58obxg38k">Senza Tennis Pronto</p>
            <p className="border-l border-emerald-300/30 p-4 text-emerald-300" data-id="element-47" data-mp="39solpjmf9fpi">
              Con Tennis Pronto
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-emerald-300/20 text-xs sm:text-sm" data-id="element-48" data-mp="3islhe578beu2">
              <p className="flex gap-2 p-4 font-medium text-slate-300" data-id="element-49" data-mp="1jolf6i0xyrdj">
                <span className="text-lime-300" data-id="element-50" data-mp="1eqjs7m0ea7ws">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-emerald-300/20 bg-emerald-300/5 p-4 font-semibold text-white" data-id="element-51" data-mp="1shgl7dy8gr4d">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-emerald-300" data-id="element-52" data-mp="1none4jfal6p4" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-53" data-mp="1xeot8lpo3erw">
          <CountdownTimer dark data-id="element-54" data-mp="1xfi49yvnsqfu" />
        </div>
        <div className="border-2 border-emerald-400 bg-[#1b2b1e] p-7 text-left" data-id="element-55" data-mp="2bg16gpdg12a3">
          <p className="text-xs font-bold uppercase tracking-widest text-emerald-300" data-id="element-56" data-mp="27dxsnu3axlln">
            Pacchetto completo
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-57" data-mp="h2jgywth9vcf">
            TENNIS PRONTO™ — 6 Volumi + 5 Bonus
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-58" data-mp="d1hhcevnfh9x">
            <div data-id="element-59" data-mp="2vpwxjgwgody">
              <p className="text-sm font-bold text-slate-300 line-through" data-id="element-60" data-mp="2x9dzcadr3gs">€106</p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-61" data-mp="6xtcokalqf51">
                €19
              </p>
            </div>
            <p className="bg-emerald-400 px-3 py-2 text-xs font-bold uppercase text-[#102016]" data-id="element-62" data-mp="3pbap3se9z45u">
              Risparmi €87
            </p>
          </div>
        </div>
        <a href="https://tennis-pronto.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-63" data-mp="3fcbn2so0m6rt">
          SCARICA IL MEGAPACK COMPLETO A €19
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-slate-300" data-id="element-64" data-mp="36eripauuvucz">
          <span className="flex gap-1" data-id="element-65" data-mp="14lbt8hai8ljl">
            <LockKeyholeIcon className="h-4 w-4 text-emerald-300" data-id="element-66" data-mp="14md7eumtho5j" />
            Pagamento sicuro
          </span>
          <span className="flex gap-1" data-id="element-67" data-mp="19jwixms4rmts">
            <ZapIcon className="h-4 w-4 text-emerald-300" data-id="element-68" data-mp="35njdmj0blhl8" />
            Accesso immediato
          </span>
          <span className="flex gap-1" data-id="element-69" data-mp="30opzqph4fokj">
            <ShieldCheckIcon className="h-4 w-4 text-emerald-300" data-id="element-70" data-mp="30protxuz2bl9" />
            Garanzia 7 giorni
          </span>
        </div>
      </div>
    </section>;
}